import React, { useState, useEffect, useMemo } from "react";
import {
  Modal,
  DatePicker,
  Form,
  InputNumber,
  Input,
  Select,
  Table,
  Button,
  message,
  Spin,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import GenreateSuccessSendMailTableModal from "./GenreateSuccessSendMailTableModal";
import "../css/GenerateProposalModal.css";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import TextArea from "antd/es/input/TextArea";

// Extend dayjs with customParseFormat
dayjs.extend(customParseFormat);

const { Option } = Select;

const GenerateProposalModal = ({
  visible,
  onOk,
  onCancel,
  enquiryId,
  service,
}) => {
  const [form] = Form.useForm();

  const [outletItem, setItems] = useState([
    {
      outletId: "",
      outlet_name: "",
      no_of_food_handlers: 0,
      man_days: 0,
      type_of_industry: "",
      unit: 0,
      description: "",
      amount: 0,
      city: "",
      no_of_production_line: 0,
      vertical_of_industry: "",
      quantity: 1, // default quantity
      unit_cost: 0,
    },
  ]);
  const [proposal_date, setProposalDate] = useState("");
  const [proposal_number, setProposalNumber] = useState("");
  const [outlets, setOutlets] = useState([]);
  const [initialValuesLoaded, setInitialValuesLoaded] = useState(false);
  const [showSendMailModal, setShowSendMailModal] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [igst, setIgst] = useState(0);
  const [total, setTotal] = useState(0);
  const [email, setEmail] = useState(0);
  const [vertical_of_industry, set_vertical_of_industry] = useState(0);
  const [type_of_industry, set_type_of_industry] = useState(0);
  const [prosposalId, setPropsalId] = useState();
  const [representaive, setRepesentaive] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [loading, setLoading] = useState(false);
  const [checkState, setCheckState] = useState("");
  const [sameState, setSameState] = useState(true);
  const [customerType, setCustomerType] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleCancel = () => {
    setItems([
      {
        outletId: "",
        outlet_name: "",
        no_of_food_handlers: 0,
        man_days: 0,
        description: "",
        amount: 0,
        quantity: 1,
        no_of_production_line: 0,
        vertical_of_industry: "",
        city: "",
        unit_cost: 0,
      },
    ]);
    setSubTotal(0);
    setSgst(0);
    setCgst(0);
    setIgst(0);
    setTotal(0);
    onCancel();
    setIsFetching(false);
    form.resetFields();
  };

  useEffect(() => {
    if (visible) {
      setProposalDate(moment());

      const fetchProposalNumber = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/api/proposal/genrateProposalNumber`
          );
          // console.log(response, "get genrate proposal number ");
          setProposalNumber(response.data);
          form.setFieldsValue({
            proposal_number: response.data.proposal_number,
          });
        } catch (error) {
          console.error("Error in fetching proposal Number", error);
        }
      };

      const fetchOutlets = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/api/proposal/getOutletDetailsById/${enquiryId}`
          );
          const outletData = response.data || [];
          console.log("this is the outlet data", outletData);
          setOutlets(outletData);

          // Map to internal items, ensure defaults
          const mapped = outletData.map((outlet) => {
            const type_of_industry = outlet.type_of_industry || "";
            const unit = outlet.unit || 0;
            const no_of_production_line = outlet?.no_of_production_line || 0;
            const vertical_of_industry = outlet.vertical_of_industry || "";
            const city = outlet.city || "";

            let man_days = 0;

            if (type_of_industry === "Catering") {
              man_days = calculateManDays(unit);
            } else if (type_of_industry === "Transportation") {
              man_days = calculateVehicleManDays(unit);
            } else if (type_of_industry === "Trade and Retail" || type_of_industry === "Storage and Warehouse") {
              man_days = calculateStorageManDays(unit);
            } else {
              man_days = calculateManufacturingManDays(unit, no_of_production_line);
            }

            return {
              outletId: outlet._id || "",
              outlet_name: outlet.branch_name || "",
              type_of_industry: type_of_industry,
              unit: unit,
              man_days: man_days,
              amount: 0,
              unit_cost: 0,
              vertical_of_industry: vertical_of_industry,
              city,
              no_of_production_line,
              quantity: outlet.quantity || 1, // ensure default quantity
              description: outlet.default_service || "",
            };
          });

          setItems(mapped);
          // Recalculate totals based on mapped
          calculateTotals(mapped);
        } catch (error) {
          console.error("Error fetching outlets", error);
        }
      };

      const fetchProfileSetting = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/api/setting/getCompanyDetail`
          );
          // console.log("here", response.data.profile.company_address.state);
          // console.log("get company detail", response);

          setCheckState(response.data.profile.company_address.state);
        } catch (error) {
          console.error("Error is fetching the profile state");
        }
      };

      const fetchBusinessDetails = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/api/proposal/getBusinessDetailsByEnquiryId/${enquiryId}`
          );
          const businessData = response.data;
          console.log("this busssiness detail data genrate proposal", businessData);
          setCustomerType(businessData.customer_type);
          setEmail(businessData.email);
          set_type_of_industry(businessData.type_of_industry);
          set_vertical_of_industry(businessData.vertical_of_industry);
          setPoNumber(businessData.po_number);

          const addressLine1 = businessData.address?.line1 || "";
          const addressLine2 = businessData.address?.line2 || "";

          const line1 = [addressLine1, addressLine2].filter(Boolean).join(", ");
          const city = businessData.address?.city || "";
          const state = businessData.address?.state || "";
          const line2 = [city, state].filter(Boolean).join(", ");

          form.setFieldsValue({
            fbo_name: businessData.name,
            address: {
              line1: line1,
              line2: line2,
            },
            pincode: businessData.address?.pincode || "",
            gst_number: businessData?.gst_number || "",
            contact_person: businessData.contact_person,
            phone: businessData.phone,
            po_number: businessData?.po_number || "",
          });

          setInitialValuesLoaded(true);
          // console.log(checkState, "checkstate-company detail");
          // console.log(state, "STATE-get outlet detail");

          const state1 = state?.trim().toLowerCase();
          const state2 = checkState?.trim().toLowerCase();

          const isSameState =
            state1?.replace(/\s+/g, "") === state2?.replace(/\s+/g, "");

          console.log(isSameState);
          // if (checkState === state) {
          if (isSameState === true) {
            setSameState(true);
            console.log(sameState, "condition check for State ")
          } else {
            setSameState(false);
            console.log(sameState, "condition check for State ")
          }
        } catch (error) {
          console.error("Error fetching business details", error);
        } finally {
          setIsFetching(false);
        }
      };

      const fetchAllrepresentaive = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/api/auth/getAllRepresentatives`
          );
          setRepesentaive(response.data.data || []);
          console.log("this is representaive data", response.data.data);
        } catch (error) {
          console.error("Error fetching auditors:", error);
        }
      };

      fetchOutlets();
      fetchProposalNumber();
      fetchAllrepresentaive();
      fetchProfileSetting();
      fetchBusinessDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, enquiryId, form, checkState]);

  const handleSubmit = async () => {
    console.log("clicked button");

    setLoading(true);
    try {
      // Validate form fields before submission
      await form.validateFields();

      // Collect form values
      const formData = form.getFieldsValue();

      // Prepare cleaned outlets to guarantee defaults
      const cleanedOutlets = outletItem.map((it) => {
        const quantity =
          it.quantity === undefined || it.quantity === null
            ? 1
            : Number(it.quantity) || 1;
        const unit_cost = Number(it.unit_cost) || 0;
        const amount =
          Number(it.amount) ||
          (quantity * unit_cost) ||
          0;

        return {
          ...it,
          quantity,
          unit_cost,
          amount,
        };
      });

      // Prepare type_of_industry / vertical_of_industry safely (handle arrays or strings)
      const safeTypeOfIndustry = Array.isArray(type_of_industry)
        ? type_of_industry[0]
        : type_of_industry;
      const safeVerticalOfIndustry = Array.isArray(vertical_of_industry)
        ? vertical_of_industry[0]
        : vertical_of_industry;

      // Prepare data to send
      const proposalData = {
        ...formData,
        enquiryId: enquiryId,
        outlets: cleanedOutlets, // send cleaned outlets
        email: email,
        type_of_industry: safeTypeOfIndustry,
        vertical_of_industry: safeVerticalOfIndustry,
        same_state: sameState,
        service: service,
        customer_type: customerType,
        po_number: poNumber,
        note: formData.note || "",
      };

      // Console: show cleaned payload for debugging
      console.log("=== Prepared proposalData ===");
      console.log(proposalData);
      console.log("=== cleanedOutlets ===");
      console.log(cleanedOutlets);

      // Make POST request to create proposal
      const response = await axios.post(
        `${apiUrl}/api/proposal/createProposalAndOutlet`,
        proposalData
      );
      // console.log("Response from createProposalAndOutlet:", response.data);
      // Get proposal ID from response and show mail modal
      setPropsalId(response.data.proposal._id);
      setShowSendMailModal(true);

      // Update enquiry status to mark proposal as done
      await axios.post(`${apiUrl}/api/enquiry/updateEnquiryProposalStatus`, {
        equiryId: enquiryId,
        isProposalDone: true,
      });
      form.resetFields();
      // Finalize actions and messages
      onOk(); // Trigger any OK handling logic (such as closing modals)
      message.success("Proposal generated and status updated successfully!");
    } catch (error) {
      console.error("Submit error: ", error);
      message.error("Failed to generate proposal or update status.");
    } finally {
      setLoading(false);
    }
  };

  const addItem = () => {
    setItems((prevItems) => {
      const newItems = [
        ...prevItems,
        {
          outletId: "",
          outlet_name: "",
          no_of_food_handlers: 0,
          man_days: 0,
          amount: 0,
          city: "",
          quantity: 1, // ensure default quantity for new rows
          unit_cost: 0,
          no_of_production_line: 0,
          type_of_industry: "",
        },
      ];
      calculateTotals(newItems);
      return newItems;
    });
  };

  const removeItem = (index) => {
    const newItems = outletItem.filter((item, i) => i !== index);
    setItems(newItems);
    calculateTotals(newItems);
  };

  const calculateHygieneRatingManDays = (foodHandlers) => {
    if (foodHandlers <= 50) return 0.5;
    if (foodHandlers <= 100) return 1;
    return 1.5;
  };

  const calculateManDays = (foodHandlers) => {
    if (foodHandlers <= 25) return 0.5;
    if (foodHandlers >= 26 && foodHandlers <= 50) return 1;
    if (foodHandlers >= 51 && foodHandlers <= 100) return 1.5;


    return 2;
  };

  const calculateStorageManDays = (area) => {
    if (area <= 15000) return 0.5;
    if (area > 15000 && area <= 50000) return 1;
    if (area > 50000) return 1.5;
    return 0;
  };

  const calculateVehicleManDays = (noOfVehicles) => {
    if (noOfVehicles <= 2) return 0.5;
    if (noOfVehicles >= 3 && noOfVehicles <= 5) return 1;
    if (noOfVehicles = 6) return 1.5;
    // if (noOfVehicles >= 6 && noOfVehicles <= 7) return 1.5;
    if (noOfVehicles >= 7 && noOfVehicles <= 10) return 2;
    return 2;
  };

  // Now includes production-line logic
  const calculateManufacturingManDays = (foodHandlers, productionLine) => {
    let manDaysFoodHandlers = 0;
    let manDaysProductionLine = 0;

    // Calculate man-days based on food handlers
    if (foodHandlers <= 50) {
      manDaysFoodHandlers = 0.5;
    } else if (foodHandlers <= 100) {
      manDaysFoodHandlers = 1;
    } else if (foodHandlers <= 300) {
      manDaysFoodHandlers = 1.5;
    } else if (foodHandlers <= 600) {
      manDaysFoodHandlers = 2;
    } else if (foodHandlers <= 1000) {
      manDaysFoodHandlers = 2.5;
    } else if (foodHandlers > 1000) {
      manDaysFoodHandlers = 3;
    }

    // Simple rule for production lines (adjust as needed)
    // if (!productionLine || productionLine <= 1) {
    //   manDaysProductionLine = 0.5;
    // } else if (productionLine <= 3) {
    //   manDaysProductionLine = 1;
    // } else if (productionLine <= 6) {
    //   manDaysProductionLine = 1.5;
    // } else {
    //   manDaysProductionLine = 2;
    // }
    if (!productionLine || productionLine <= 1) {
      manDaysProductionLine = 0.5;
    } else if (productionLine <= 2) {
      manDaysProductionLine = 1;
    } else if (productionLine <= 4) {
      manDaysProductionLine = 1.5;
    } else if (productionLine <= 6) {
      manDaysProductionLine = 2;
    } else if (productionLine <= 8) {
      manDaysProductionLine = 2.5;
    } else {
      // 10+
      manDaysProductionLine = 3;
    }

    return Math.max(manDaysFoodHandlers, manDaysProductionLine);
  };
  // console.log(service, "in genrate proposal model");
  const handleInputChange = (index, field, value) => {
    setItems((prevItems) => {
      const newItems = [...prevItems];
      const currentItem = { ...(newItems[index] || {}) };

      if (field === "outletId") {
        if (value === "others") {
          newItems[index] = {
            ...currentItem,
            outletId: value,
            outlet_name: "Others",
            unit: 0,
            man_days: 0,
            amount: 0,
            quantity: 1,
            type_of_industry: "",
            unit_cost: 0,
            no_of_production_line: 0,
          };
        } else {
          const selectedOutlet = outlets.find((outlet) => outlet._id === value);

          const type_of_industry = selectedOutlet?.type_of_industry || "";
          const unit = selectedOutlet?.unit || 0;
          const no_of_production_line =
            selectedOutlet?.no_of_production_line || 0;
          let man_days = 0;

          // if (type_of_industry === "Catering" ) {
          //   man_days = calculateManDays(unit);
          // } else if (type_of_industry === "Transportation") {
          //   man_days = calculateVehicleManDays(unit);
          // } else if (type_of_industry === "Trade and Retail") {
          //   man_days = calculateStorageManDays(unit);
          // } else {
          //   man_days = calculateManufacturingManDays(unit, no_of_production_line);
          // }

          const selectedService =
            selectedOutlet?.default_service ||
            selectedOutlet?.service ||
            "";

          if (selectedService === "Hygiene Rating") {
            man_days = calculateHygieneRatingManDays(unit);
          } else if (type_of_industry === "Catering") {
            man_days = calculateManDays(unit);
          } else if (type_of_industry === "Transportation") {
            man_days = calculateVehicleManDays(unit);
          } else if (type_of_industry === "Trade and Retail" || type_of_industry === "Storage and Warehouse") {
            man_days = calculateStorageManDays(unit);
          } else {
            man_days = calculateManufacturingManDays(
              unit,
              no_of_production_line
            );
          }

          newItems[index] = {
            ...currentItem,
            outletId: value,
            type_of_industry: selectedOutlet?.type_of_industry || "",
            vertical_of_industry: selectedOutlet?.vertical_of_industry || "",
            outlet_name: selectedOutlet?.branch_name || "",
            unit: selectedOutlet?.unit || 0,
            city: selectedOutlet?.city || "",
            service: selectedOutlet?.service || 0,
            amount: 0,
            unit_cost: 0,
            man_days,
            no_of_production_line,
            quantity: selectedOutlet?.quantity || 1,
          };
        }
      } else if (field === "unit_cost") {
        newItems[index] = {
          ...currentItem,
          unit_cost: value,
          amount: (currentItem.quantity || 1) * (value || 0),
        };
      } else if (field === "quantity") {
        newItems[index] = {
          ...currentItem,
          quantity: value,
          amount: (value || 0) * (currentItem.unit_cost || 0),
        };
      }
      // else if (field === "description") {
      //   newItems[index] = {
      //     ...currentItem,
      //     description: value,
      //   };
      // } 

      else if (field === "description") {
        let man_days = currentItem.man_days;

        if (value === "Hygiene Rating") {
          man_days = calculateHygieneRatingManDays(
            currentItem.unit || 0
          );
        } else if (currentItem.type_of_industry === "Catering") {
          man_days = calculateManDays(currentItem.unit || 0);
        } else if (currentItem.type_of_industry === "Transportation") {
          man_days = calculateVehicleManDays(
            currentItem.unit || 0
          );
        } else if (currentItem.type_of_industry === "Trade and Retail" || currentItem.type_of_industry === "Storage and Warehouse") {
          man_days = calculateStorageManDays(
            currentItem.unit || 0
          );
        } else {
          man_days = calculateManufacturingManDays(
            currentItem.unit || 0,
            currentItem.no_of_production_line || 0
          );
        }

        newItems[index] = {
          ...currentItem,
          description: value,
          man_days,
        };
      }
      else if (field === "unit") {
        newItems[index] = {
          ...currentItem,
          unit: value,
        };
        // // Recompute man_days depending on type_of_industry
        // if (currentItem.type_of_industry === "Catering") {
        //   newItems[index].man_days = calculateManDays(value);
        // } else if (currentItem.type_of_industry === "Transportation") {
        //   newItems[index].man_days = calculateVehicleManDays(value);
        // } else if (currentItem.type_of_industry === "Trade and Retail") {
        //   newItems[index].man_days = calculateStorageManDays(value);
        // } else if (currentItem.type_of_industry === "Manufacturing") {
        //   newItems[index].man_days = calculateManufacturingManDays(value, currentItem.no_of_production_line || 0);
        // }

        if (currentItem.description === "Hygiene Rating") {
          newItems[index].man_days =
            calculateHygieneRatingManDays(value);
        } else if (currentItem.type_of_industry === "Catering") {
          newItems[index].man_days = calculateManDays(value);
        } else if (currentItem.type_of_industry === "Transportation") {
          newItems[index].man_days =
            calculateVehicleManDays(value);
        } else if (currentItem.type_of_industry === "Trade and Retail" || currentItem.type_of_industry === "Storage and Warehouse") {
          newItems[index].man_days =
            calculateStorageManDays(value);
        } else if (currentItem.type_of_industry === "Manufacturing") {
          newItems[index].man_days =
            calculateManufacturingManDays(
              value,
              currentItem.no_of_production_line || 0
            );
        }

      } else if (field === "no_of_production_line") {
        newItems[index] = {
          ...currentItem,
          no_of_production_line: value,
        };
        // if manufacturing, update man_days
        if (currentItem.type_of_industry === "Manufacturing") {
          newItems[index].man_days = calculateManufacturingManDays(currentItem.unit || 0, value);
        }
      } else if (field === "man_days") {
        newItems[index] = {
          ...currentItem,
          man_days: value,
        };
      }

      // Recalculate totals
      calculateTotals(newItems);

      return newItems;
    });
  };

  const calculateTotals = (items) => {
    if (!Array.isArray(items) || items.length === 0) {
      setSubTotal(0);
      if (sameState) {
        setSgst(0);
        setCgst(0);
      } else {
        setIgst(0);
        setSgst(0);
      }

      setTotal(0);
      return;
    }

    const calculatedSubTotal = items.reduce(
      (sum, item) => sum + (parseFloat(item.amount) || 0),
      0
    );
    const calculatedSubTotalWithAuditorFee = calculatedSubTotal + (form.getFieldValue("auditor_convenience_fee") || 0);
    setSubTotal(calculatedSubTotalWithAuditorFee);
    // setSubTotal(calculatedSubTotal);
    if (sameState) {
      const calculatedSgst = calculatedSubTotalWithAuditorFee * 0.09;
      const calculatedCgst = calculatedSubTotalWithAuditorFee * 0.09;
      // const calculatedSgst = calculatedSubTotal * 0.09;
      // const calculatedCgst = calculatedSubTotal * 0.09;

      setSgst(calculatedSgst);
      setCgst(calculatedCgst);
      const calculatedTotal =
        calculatedSubTotalWithAuditorFee + calculatedSgst + calculatedCgst;
      setTotal(calculatedTotal);
    } else {
      const calculatedGst = calculatedSubTotalWithAuditorFee * 0.18;
      const calculatedIgst = calculatedSubTotalWithAuditorFee * 0.18;
      const calculatedSgst = calculatedSubTotalWithAuditorFee * 0;
      // const calculatedGst = calculatedSubTotal * 0.18;
      // const calculatedIgst = calculatedSubTotal * 0.09;
      // const calculatedSgst = calculatedSubTotal * 0.09;

      setIgst(calculatedIgst);
      setSgst(calculatedSgst);
      const calculatedTotal = calculatedSubTotalWithAuditorFee + calculatedIgst + calculatedSgst;
      setTotal(calculatedTotal);
    }
  };

  // Determine whether any row is Manufacturing — used to show/hide the column
  const hasManufacturingRow = useMemo(
    () =>
      Array.isArray(outletItem) &&
      outletItem.some((it) => it.type_of_industry === "Manufacturing"),
    [outletItem]
  );

  const columnsBase = [
    {
      title: "Outlet name",
      dataIndex: "outletId",
      render: (text, record, index) => (
        <Select
          value={text}
          onChange={(value) => handleInputChange(index, "outletId", value)}
          className="w-full"
          style={{ width: 100 }}
        >
          <Option value="others">Others</Option>
          {outlets.map((outlet) => (
            <Option key={outlet._id} value={outlet._id}>
              {/* {outlet.branch_name} */}
              {`${outlet.branch_name || ""} - ${outlet.city || ""}`}

            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Services",
      dataIndex: "description",
      render: (text, record, index) => {
        const isOthers = record.outletId === "others";
        return isOthers ? (
          <Input
            value={text}
            onChange={(e) =>
              handleInputChange(index, "description", e.target.value)
            }
            className="w-full"
          />
        ) : (
          <Select
            value={text}
            className=""
            style={{ width: 90 }}
            onChange={(value) => handleInputChange(index, "description", value)}
          >
            <Option value="TPA">TPA</Option>
            <Option value="Hygiene Rating">Hygiene Rating</Option>
            <Option value="Eat Right Station (Pre-Audit)">Eat Right Station(Pre-Audit)</Option>
            <Option value="Eat Right Station (Final-Audit)">Eat Right Station(Final-Audit)</Option>
            <Option value="Eat Right Station (One-Time)">Eat Right Station(One-Time)</Option>
            <Option value="Clean and Fresh Fruit and Vegetable Market (Pre-Audit)">
              Clean and Fresh Fruit and Vegetable Market(Pre-Audit)
            </Option>
            <Option value="Clean and Fresh Fruit and Vegetable Market (Final-Audit)">
              Clean and Fresh Fruit and Vegetable Market(Final-Audit)
            </Option>
            <Option value="Clean and Fresh Fruit and Vegetable Market (One-Time)">
              Clean and Fresh Fruit and Vegetable Market(One-Time)
            </Option>
            <Option value="Clean Street Food Hub (Pre-Audit)">Clean Street Food Hub(Pre-Audit)</Option>
            <Option value="Clean Street Food Hub (Final-Audit)">Clean Street Food Hub(Final-Audit)</Option>
            <Option value="Clean Street Food Hub (One-Time)">Clean Street Food Hub(One-Time)</Option>
            <Option value="Eat Right Campus (Pre-Audit)">Eat Right Campus(Pre-Audit)</Option>
            <Option value="Eat Right Campus (Final-Audit)">Eat Right Campus(Final-Audit)</Option>
            <Option value="Eat Right Campus (One-Time)">Eat Right Campus(One-Time)</Option>
            <Option value="BHOG (Blissful Hygienic Offering to God) (Pre-Audit)">BHOG (Blissful Hygienic Offering to God)(Pre-Audit)</Option>
            <Option value="BHOG (Blissful Hygienic Offering to God) (Final-Audit)">BHOG (Blissful Hygienic Offering to God)(Final-Audit)</Option>
            <Option value="BHOG (Blissful Hygienic Offering to God) (One-Time)">BHOG (Blissful Hygienic Offering to God)(One-Time)</Option>
          </Select>
        );
      },
    },
    {
      title: "Criteria",
      dataIndex: "unit",
      render: (text, record, index) => {
        const isOthers = record.outletId === "others";
        let postfix = "";

        switch (record.type_of_industry) {
          case "Transportation":
            postfix = "VH";
            break;
          case "Catering":
            postfix = "FH";
            break;
          case "Trade and Retail":
          case "Storage and Warehouse":
            postfix = "Sq ft";
            break;
          case "Manufacturing":
            postfix = "FH";
            break;
          default:
            postfix = "";
        }

        console.log("Switch ch triggered", postfix);

        return isOthers ? (
          <Input disabled className="w-full" />
        ) : (
          <div className="flex items-center">
            <InputNumber
              min={0}
              value={text}
              onChange={(value) => handleInputChange(index, "unit", value)}
              className="w-full"
            />
            <span className="ml-1" style={{ width: 50 }}>
              {postfix}
            </span>
          </div>
        );
      },
    },
    // Conditionally add Production Line column later
    {
      title: "Man Days",
      dataIndex: "man_days",
      render: (text, record, index) => {
        const isOthers = record.outletId === "others";
        return isOthers ? (
          <Input disabled className="w-full" />
        ) : (
          <InputNumber
            min={0}
            value={text}
            onChange={(value) => handleInputChange(index, "man_days", value)}
            className="w-full"
          />
        );
      },
    },
    {
      title: "QTY",
      dataIndex: "quantity",
      render: (text, record, index) => (
        <InputNumber
          min={1}
          value={text ?? 1}
          onChange={(value) =>
            handleInputChange(index, "quantity", value ?? 1)
          }
          className="w-full"
        />
      ),
    },
    {
      title: "Unit Cost(₹) ",
      dataIndex: "unit_cost",
      render: (text, record, index) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => handleInputChange(index, "unit_cost", value)}
          className="w-full"
        />
      ),
    },
    {
      title: "Amount(₹)",
      dataIndex: "amount",
      render: (text = 0) =>
        Number(text).toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, __, index) => (
        <Button
          onClick={() => removeItem(index)}
          type="link"
          danger
          icon={<DeleteOutlined />}
        />
      ),
    },
  ];

  // Build final columns array: if any row is Manufacturing, insert Production Line column after Criteria
  const columns = useMemo(() => {
    const cols = [...columnsBase];
    if (hasManufacturingRow) {
      // Insert the Production Line column after Criteria (index 2)
      cols.splice(3, 0, {
        title: "Production Line",
        dataIndex: "no_of_production_line",
        render: (text, record, index) => {
          const isOthers = record.outletId === "others";
          return isOthers ? (
            <Input disabled className="w-full" />
          ) : (
            <div className="flex items-center">
              <InputNumber
                min={0}
                value={text ?? 0}
                onChange={(value) =>
                  handleInputChange(index, "no_of_production_line", value)
                }
                className="w-full"
              />
              {/* <span className="ml-2" style={{ width: 50 }}>
                  {"PD/Line"}
                </span> */}
            </div>
          );
        },
      });
    }
    return cols;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasManufacturingRow, outlets, outletItem]);

  const handleOk = () => {
    setShowSendMailModal(false);
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        width={1000}
        style={{ padding: "0 !important" }}
        className="acc-modal"
      >
        <Spin spinning={isFetching}>
          <Form layout="vertical" onFinish={handleSubmit} form={form}>
            <div
              className="text-center align-middle font-medium text-xl title-div bg-blue-50 p-7"
              style={{ boxShadow: "0 4px 2px -2px lightgrey" }}
            >
              Generate Proposal
            </div>
            <div
              className="px-8 pt-4 pb-8"
              style={{ backgroundColor: "#F6FAFB" }}
            >
              <div className="text-center font-medium text-xl mb-5 rounded-md">
                Document Preview
              </div>
              <div className="flex space-x-4">
                <Form.Item
                  label="FBO name (Business Name)"
                  name="fbo_name"
                  className="flex-1"
                  rules={[
                    {
                      required: true,
                      message: "Please input the business name!",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </Form.Item>

                <Form.Item
                  label="Proposal date"
                  className="flex-1"
                  name="proposal_date"
                  rules={[
                    {
                      required: true,
                      message: "Please select the Proposal Date!",
                    },
                  ]}
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    className="w-full"
                    onChange={(date) => {
                      form.setFieldValue("proposal_date", date);
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label="Proposal number"
                  name="proposal_number"
                  className="flex-1"
                >
                  <Input
                    placeholder="Auto Generated"
                    className="w-full p-2 border border-gray-300 rounded"
                    readOnly
                  />
                </Form.Item>
                <Form.Item
                  label="PO Number"
                  name="po_number"
                  className="flex-1"
                >
                  <Input
                    placeholder="PO Number"
                    className="w-full p-2 border border-gray-300 rounded"

                  />
                </Form.Item>
              </div>
              <Form.Item label="Address">
                <Input.Group>
                  <Form.Item
                    name={["address", "line1"]}
                    rules={[
                      {
                        required: true,
                        message: "Please input the address line 1!",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      className="w-full p-2 border border-gray-300 rounded"
                    />
                  </Form.Item>
                  <Form.Item name={["address", "line2"]}>
                    <Input
                      type="text"
                      className="w-full p-2 border border-gray-300 rounded"
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
              <div className="flex space-x-4">
                <Form.Item
                  label="Pincode"
                  name="pincode"
                  className="flex-1"
                  rules={[{ required: true, message: "Please input the pincode!" }]}
                >
                  <Input
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </Form.Item>
                <Form.Item
                  label="GST Number"
                  name="gst_number"
                  className="flex-1"
                  rules={[{ message: "Please input the GST number!" }]}
                >
                  <Input
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </Form.Item>
              </div>
              <div className="flex space-x-4">
                <Form.Item
                  label="Contact Person Name"
                  name="contact_person"
                  className="flex-1"
                  rules={[
                    {
                      required: true,
                      message: "Please input the contact person name!",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </Form.Item>
                <Form.Item
                  label="Contact Person Number"
                  name="phone"
                  className="flex-1"
                  rules={[
                    {
                      required: true,
                      message: "Please input the contact person number!",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded"
                  />
                </Form.Item>
              </div>
              <Form.Item
                name="representative"
                label="Representative"
                rules={[{ required: true, message: "Please select Representative!" }]}
              >
                <Select placeholder="Select Representative">
                  {representaive.map((representaive) => (
                    <Option key={representaive._id} value={representaive._id}>
                      {representaive.userName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="auditor_convenience_fee"
                label="Auditor Convenience Fee (₹)"
                rules={[
                  {
                    type: "number",
                    min: 0,
                    message: "Fee must be a positive number",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  placeholder="Enter convenience fee"
                  className="w-full"
                  formatter={(value) =>
                    `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
                  onChange={() => calculateTotals(outletItem)}
                />
              </Form.Item>

              <div className="my-4">
                <h3 className="text-lg font-semibold mb-2">Items table</h3>
                <Table
                  dataSource={outletItem}
                  columns={columns}
                  pagination={false}
                  rowKey={(record, idx) => `${record.outletId}-${idx}`}
                />
                <button
                  type="button"
                  onClick={addItem}
                  className="mt-2 px-4 py-2 bg-blue-500 text-white rounded"
                >
                  + Add New Row
                </button>
              </div>
              <div className="border-t pt-4">
                <Form.Item label="Note" name="note">
                  <TextArea rows={4} placeholder="Enter any additional details" />
                </Form.Item>
              </div>
              <div className="my-4 p-4 border rounded w-1/2 ml-auto bg-gray-50">
                <div className="flex justify-between items-center">
                  <div className="text-sm font-medium">Sub Total:</div>
                  <div className="text-sm font-medium">
                    {subTotal.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "INR",
                    })}
                  </div>
                </div>

                {sameState ? (
                  <>
                    <div className="flex justify-between items-center">
                      <div className="text-sm font-medium">SGST (9%):</div>
                      <div className="text-sm font-medium">
                        {sgst.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-sm font-medium">CGST (9%):</div>
                      <div className="text-sm font-medium">
                        {cgst.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-sm font-medium">IGST (18%):</div>
                      <div className="text-sm font-medium">
                        {igst.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </div>
                    </div>
                  </>
                ) : (
                  // <div className="flex justify-between items-center">
                  //   <div className="text-sm font-medium">IGST (18%):</div>
                  //   <div className="text-sm font-medium">
                  //     {igst.toLocaleString("en-IN", {
                  //       style: "currency",
                  //       currency: "INR",
                  //     })}
                  //   </div>
                  // </div>
                  <><div className="flex justify-between items-center">
                    <div className="text-sm font-medium">IGST (18%):</div>
                    <div className="text-sm font-medium">
                      {igst.toLocaleString("en-IN", {
                        style: "currency",
                        currency: "INR",
                      })}
                    </div>
                  </div>
                    <div className="flex justify-between items-center">
                      <div className="text-sm font-medium">SGST (9%):</div>
                      <div className="text-sm font-medium">
                        {sgst.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="text-sm font-medium">CGST (9%):</div>
                      <div className="text-sm font-medium">
                        {cgst.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </div>
                    </div></>
                )}

                <div className="flex justify-between items-center">
                  <div className="text-lg font-bold">Total:</div>
                  <div className="text-lg font-bold">
                    {total.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "INR",
                    })}
                  </div>
                </div>
              </div>

              <div className="text-center mt-4">
                <button
                  className="bg-black px-4 py-2 text-white rounded"
                  htmlType="submit"
                  onClick={() => form.submit()}
                  disabled={loading}
                >
                  {loading ? "Generating..." : "Generate"}
                </button>
              </div>
            </div>
          </Form>
        </Spin>
      </Modal>

      <GenreateSuccessSendMailTableModal
        onClose={() => setShowSendMailModal(false)}
        id={prosposalId}
        onOk={handleOk}
        title="Generate Proposal"
        name="proposal"
        route="generateProposal"
        visible={showSendMailModal}
        buttonTitle="Go to Proposal"
      />
    </>
  );
};

export default GenerateProposalModal;
